import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=f9e2f98e&scoped=true&"
import script from "./StackedBarChart.vue?vue&type=script&lang=js&"
export * from "./StackedBarChart.vue?vue&type=script&lang=js&"
import style0 from "./StackedBarChart.vue?vue&type=style&index=0&id=f9e2f98e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e2f98e",
  null
  
)

export default component.exports